import * as React from "react";
import { Paper, Stack, Box, Typography, Snackbar, Alert } from "@mui/material";
import { scheduleFlowRuns } from "../../http/api";
import type { selectedYear } from "../../store/features/envSlice";
import type { ClientFlow, DeploymentMode } from "./types";
import { RunSelector } from "./RunSelector";
import { RecapButton } from "./RecapButtons"; // <- corrigé (singulier)

export default function Riverflows() {
  const [deployment, setDeployment] = React.useState<string>("");
  const [deploymentMode, setDeploymentMode] = React.useState<DeploymentMode>("Deployment");

  const [runPhase, setRunPhase] = React.useState<string>("");
  const [clients, setClients] = React.useState<ClientFlow[]>([]);
  const [clientYears, setClientYears] = React.useState<selectedYear[]>([]);

  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackMsg, setSnackMsg] = React.useState("");
  const [snackType, setSnackType] = React.useState<"success" | "error">("success");
  const handleSnackClose = () => setSnackOpen(false);

  // Valeur réellement envoyée à l'API selon l'env + le mode sélectionné
  const effectiveDeployment = React.useMemo(() => {
    if (deployment?.toLowerCase() === "development"){
      switch (deploymentMode) {
        case "Light":
          return "low_development";
        case "Heavy":
          return "high_development";
        case "Deployment":
        default:
          return "development";
      }
    } else {
      switch (deploymentMode) {
        case "Light":
          return "low_production"
        case "Heavy":
          return "high_production"
        case "Deployment":
        default:
          return "production"
      }
    }
  }, [deployment, deploymentMode]);

  const handleSendFlowRun = () => {
    scheduleFlowRuns(effectiveDeployment, runPhase, clientYears)
      .then((res: any) => {
        if (res?.status === 200) {
          setSnackMsg("Exécution programmée avec succès");
          setSnackType("success");
        } else {
          setSnackMsg("Erreur lors de l'exécution");
          setSnackType("error");
        }
        setSnackOpen(true);
      })
      .catch(() => {
        setSnackMsg("Erreur lors de l'exécution");
        setSnackType("error");
        setSnackOpen(true);
      })
      .finally(() => setDeployment(""));
  };

  return (
    <Stack spacing={3}>
      <Typography variant="h4" className="bold">
        River Flows
      </Typography>
      <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
        <RunSelector
          deployment={deployment}
          setDeployment={setDeployment}
          deploymentMode={deploymentMode}
          setDeploymentMode={setDeploymentMode}
          runPhase={runPhase}
          setRunPhase={setRunPhase}
          clientYears={clientYears}
          setClientYears={setClientYears}
          clients={clients}
          setClients={setClients}
        />
      </Paper>
      <Box>
        <RecapButton
          enabled={clientYears.length !== 0 && runPhase !== ""}
          clients={clients}
          clientYears={clientYears}
          deployment={deployment}
          deploymentMode={deploymentMode}
          runPhase={runPhase}
          handleSendFlowRun={handleSendFlowRun}
        />
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={snackOpen}
        autoHideDuration={4000}
        onClose={handleSnackClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackClose} severity={snackType} sx={{ width: "100%" }}>
          {snackMsg}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
